// extracted by mini-css-extract-plugin
module.exports = {"dueDateItem":"paymentusagedetail_dueDateItem__1z_TX","btnCol":"paymentusagedetail_btnCol__3YmgL"};